import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class TimeScheduleService extends ServiceCRUD {
  constructor() {
    super('/api/schedule-time');
  }
}

export default new TimeScheduleService();
